module.exports = __webpack_public_path__ + "static/media/TN-Men-Tshirts.95a30bcc.svg";